/* import __COLOCATED_TEMPLATE__ from './monitor-filter.hbs'; */
/* RESPONSIBLE TEAM: team-rd-services */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { action } from '@ember/object';
import type IntlService from 'embercom/services/intl';
import type InboxSidebarService from 'embercom/services/inbox-sidebar-service';
import type RouterService from '@ember/routing/router-service';
import type { Monitor } from 'embercom/services/monitors-api';

interface Signature {
  Args: {
    monitorId?: string;
  };
  Element: HTMLElement;
}

interface MonitorDropdownItem {
  text: string;
  value: string;
  isSelected: boolean;
  component: string;
}

export default class MonitorFilter extends Component<Signature> {
  @service declare intl: IntlService;
  @service declare inboxSidebarService: InboxSidebarService;
  @service declare router: RouterService;

  get monitorLabel() {
    return this.intl.t('inbox.search.filters.monitor.label');
  }

  get currentMonitor(): Monitor | undefined {
    return this.inboxSidebarService.currentMonitor;
  }

  get displayName() {
    return this.currentMonitor?.name || '';
  }

  get monitors(): Monitor[] {
    return this.inboxSidebarService.monitors;
  }

  get items() {
    let monitorItems: MonitorDropdownItem[] = this.monitors.map((monitor) => ({
      text: monitor.name,
      value: monitor.id,
      isSelected: monitor.id === this.args.monitorId,
      component: 'inbox2/left-nav/conversation-list/filters-item',
    }));

    let groups = [{ items: monitorItems }];

    if (this.args.monitorId) {
      groups.push({
        items: [
          {
            text: this.intl.t('inbox.search.filters.monitor.clear'),
            value: '',
            isSelected: false,
            component: 'inbox2/left-nav/conversation-list/filters-item',
          },
        ],
      });
    }

    return groups;
  }

  @action
  onSelectMonitor(selectedValue: string | null) {
    let monitorId = selectedValue || null;

    this.router.transitionTo('inbox.workspace.inbox.search', {
      queryParams: {
        monitor: monitorId,
      },
    });

    this.inboxSidebarService.setMonitorMode(monitorId || undefined);
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Inbox2::Search::MonitorFilter': typeof MonitorFilter;
  }
}
